"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
function compileScrollStyle(branding) {
    const { scroll = {} } = branding;
    return (0, utils_1.process)({
        'scroll-margin-right': scroll === null || scroll === void 0 ? void 0 : scroll.marginRight,
        'scroll-padding-right': scroll === null || scroll === void 0 ? void 0 : scroll.paddingRight,
        'long-text-textarea-scrollbar-thumb-color': scroll === null || scroll === void 0 ? void 0 : scroll.thumbColor,
        'long-text-textarea-scrollbar-track-color': scroll === null || scroll === void 0 ? void 0 : scroll.trackColor
    });
}
exports.default = compileScrollStyle;
